"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Event = _interopRequireDefault(require("./events/Event.js"));

var _Object = _interopRequireDefault(require("./Object.js"));

var _EventType = _interopRequireDefault(require("./events/EventType.js"));

var _Polygon = require("./geom/Polygon.js");

var _proj = require("./proj.js");

var _math = require("./math.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/Geolocation
 */


/**
 * @enum {string}
 */
var Property = {
  ACCURACY: 'accuracy',
  ACCURACY_GEOMETRY: 'accuracyGeometry',
  ALTITUDE: 'altitude',
  ALTITUDE_ACCURACY: 'altitudeAccuracy',
  HEADING: 'heading',
  POSITION: 'position',
  PROJECTION: 'projection',
  SPEED: 'speed',
  TRACKING: 'tracking',
  TRACKING_OPTIONS: 'trackingOptions'
};
/**
 * @classdesc
 * Events emitted on Geolocation error.
 */

var GeolocationError =
/** @class */
function (_super) {
  __extends(GeolocationError, _super);
  /**
   * @param {GeolocationPositionError} error error object.
   */


  function GeolocationError(error) {
    var _this = _super.call(this, _EventType["default"].ERROR) || this;
    /**
     * @type {number}
     */


    _this.code = error.code;
    /**
     * @type {string}
     */

    _this.message = error.message;
    return _this;
  }

  return GeolocationError;
}(_Event["default"]);
/**
 * @typedef {Object} Options
 * @property {boolean} [tracking=false] Start Tracking right after
 * instantiation.
 * @property {PositionOptions} [trackingOptions] Tracking options.
 * See https://www.w3.org/TR/geolocation-API/#position_options_interface.
 * @property {import("./proj.js").ProjectionLike} [projection] The projection the position
 * is reported in.
 */

/**
 * @typedef {import("./ObjectEventType").Types|'change:accuracy'|'change:accuracyGeometry'|'change:altitude'|
 *    'change:altitudeAccuracy'|'change:heading'|'change:position'|'change:projection'|'change:speed'|'change:tracking'|
 *    'change:trackingOptions'} GeolocationObjectEventTypes
 */

/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<GeolocationObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").OnSignature<'error', GeolocationError, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|GeolocationObjectEventTypes|
 *     'error', Return>} GeolocationOnSignature
 */

/**
 * @classdesc
 * Helper class for providing HTML5 Geolocation capabilities.
 * The [Geolocation API](https://www.w3.org/TR/geolocation-API/)
 * is used to locate a user's position.
 *
 * To get notified of position changes, register a listener for the generic
 * `change` event on your instance of {@link module:ol/Geolocation~Geolocation}.
 *
 * Example:
 *
 *     var geolocation = new Geolocation({
 *       // take the projection to use from the map's view
 *       projection: view.getProjection()
 *     });
 *     // listen to changes in position
 *     geolocation.on('change', function(evt) {
 *       window.console.log(geolocation.getPosition());
 *     });
 *
 * @fires module:ol/events/Event~BaseEvent#event:error
 * @api
 */


var Geolocation =
/** @class */
function (_super) {
  __extends(Geolocation, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function Geolocation(opt_options) {
    var _this = _super.call(this) || this;
    /***
     * @type {GeolocationOnSignature<import("./events").EventsKey>}
     */


    _this.on;
    /***
     * @type {GeolocationOnSignature<import("./events").EventsKey>}
     */

    _this.once;
    /***
     * @type {GeolocationOnSignature<void>}
     */

    _this.un;
    var options = opt_options || {};
    /**
     * The unprojected (EPSG:4326) device position.
     * @private
     * @type {?import("./coordinate.js").Coordinate}
     */

    _this.position_ = null;
    /**
     * @private
     * @type {import("./proj.js").TransformFunction}
     */

    _this.transform_ = _proj.identityTransform;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.watchId_ = undefined;

    _this.addChangeListener(Property.PROJECTION, _this.handleProjectionChanged_);

    _this.addChangeListener(Property.TRACKING, _this.handleTrackingChanged_);

    if (options.projection !== undefined) {
      _this.setProjection(options.projection);
    }

    if (options.trackingOptions !== undefined) {
      _this.setTrackingOptions(options.trackingOptions);
    }

    _this.setTracking(options.tracking !== undefined ? options.tracking : false);

    return _this;
  }
  /**
   * Clean up.
   */


  Geolocation.prototype.disposeInternal = function () {
    this.setTracking(false);

    _super.prototype.disposeInternal.call(this);
  };
  /**
   * @private
   */


  Geolocation.prototype.handleProjectionChanged_ = function () {
    var projection = this.getProjection();

    if (projection) {
      this.transform_ = (0, _proj.getTransformFromProjections)((0, _proj.get)('EPSG:4326'), projection);

      if (this.position_) {
        this.set(Property.POSITION, this.transform_(this.position_));
      }
    }
  };
  /**
   * @private
   */


  Geolocation.prototype.handleTrackingChanged_ = function () {
    if ('geolocation' in navigator) {
      var tracking = this.getTracking();

      if (tracking && this.watchId_ === undefined) {
        this.watchId_ = navigator.geolocation.watchPosition(this.positionChange_.bind(this), this.positionError_.bind(this), this.getTrackingOptions());
      } else if (!tracking && this.watchId_ !== undefined) {
        navigator.geolocation.clearWatch(this.watchId_);
        this.watchId_ = undefined;
      }
    }
  };
  /**
   * @private
   * @param {GeolocationPosition} position position event.
   */


  Geolocation.prototype.positionChange_ = function (position) {
    var coords = position.coords;
    this.set(Property.ACCURACY, coords.accuracy);
    this.set(Property.ALTITUDE, coords.altitude === null ? undefined : coords.altitude);
    this.set(Property.ALTITUDE_ACCURACY, coords.altitudeAccuracy === null ? undefined : coords.altitudeAccuracy);
    this.set(Property.HEADING, coords.heading === null ? undefined : (0, _math.toRadians)(coords.heading));

    if (!this.position_) {
      this.position_ = [coords.longitude, coords.latitude];
    } else {
      this.position_[0] = coords.longitude;
      this.position_[1] = coords.latitude;
    }

    var projectedPosition = this.transform_(this.position_);
    this.set(Property.POSITION, projectedPosition);
    this.set(Property.SPEED, coords.speed === null ? undefined : coords.speed);
    var geometry = (0, _Polygon.circular)(this.position_, coords.accuracy);
    geometry.applyTransform(this.transform_);
    this.set(Property.ACCURACY_GEOMETRY, geometry);
    this.changed();
  };
  /**
   * @private
   * @param {GeolocationPositionError} error error object.
   */


  Geolocation.prototype.positionError_ = function (error) {
    this.dispatchEvent(new GeolocationError(error));
  };
  /**
   * Get the accuracy of the position in meters.
   * @return {number|undefined} The accuracy of the position measurement in
   *     meters.
   * @observable
   * @api
   */


  Geolocation.prototype.getAccuracy = function () {
    return (
      /** @type {number|undefined} */
      this.get(Property.ACCURACY)
    );
  };
  /**
   * Get a geometry of the position accuracy.
   * @return {?import("./geom/Polygon.js").default} A geometry of the position accuracy.
   * @observable
   * @api
   */


  Geolocation.prototype.getAccuracyGeometry = function () {
    return (
      /** @type {?import("./geom/Polygon.js").default} */
      this.get(Property.ACCURACY_GEOMETRY) || null
    );
  };
  /**
   * Get the altitude associated with the position.
   * @return {number|undefined} The altitude of the position in meters above mean
   *     sea level.
   * @observable
   * @api
   */


  Geolocation.prototype.getAltitude = function () {
    return (
      /** @type {number|undefined} */
      this.get(Property.ALTITUDE)
    );
  };
  /**
   * Get the altitude accuracy of the position.
   * @return {number|undefined} The accuracy of the altitude measurement in
   *     meters.
   * @observable
   * @api
   */


  Geolocation.prototype.getAltitudeAccuracy = function () {
    return (
      /** @type {number|undefined} */
      this.get(Property.ALTITUDE_ACCURACY)
    );
  };
  /**
   * Get the heading as radians clockwise from North.
   * Note: depending on the browser, the heading is only defined if the `enableHighAccuracy`
   * is set to `true` in the tracking options.
   * @return {number|undefined} The heading of the device in radians from north.
   * @observable
   * @api
   */


  Geolocation.prototype.getHeading = function () {
    return (
      /** @type {number|undefined} */
      this.get(Property.HEADING)
    );
  };
  /**
   * Get the position of the device.
   * @return {import("./coordinate.js").Coordinate|undefined} The current position of the device reported
   *     in the current projection.
   * @observable
   * @api
   */


  Geolocation.prototype.getPosition = function () {
    return (
      /** @type {import("./coordinate.js").Coordinate|undefined} */
      this.get(Property.POSITION)
    );
  };
  /**
   * Get the projection associated with the position.
   * @return {import("./proj/Projection.js").default|undefined} The projection the position is
   *     reported in.
   * @observable
   * @api
   */


  Geolocation.prototype.getProjection = function () {
    return (
      /** @type {import("./proj/Projection.js").default|undefined} */
      this.get(Property.PROJECTION)
    );
  };
  /**
   * Get the speed in meters per second.
   * @return {number|undefined} The instantaneous speed of the device in meters
   *     per second.
   * @observable
   * @api
   */


  Geolocation.prototype.getSpeed = function () {
    return (
      /** @type {number|undefined} */
      this.get(Property.SPEED)
    );
  };
  /**
   * Determine if the device location is being tracked.
   * @return {boolean} The device location is being tracked.
   * @observable
   * @api
   */


  Geolocation.prototype.getTracking = function () {
    return (
      /** @type {boolean} */
      this.get(Property.TRACKING)
    );
  };
  /**
   * Get the tracking options.
   * See https://www.w3.org/TR/geolocation-API/#position-options.
   * @return {PositionOptions|undefined} PositionOptions as defined by
   *     the [HTML5 Geolocation spec
   *     ](https://www.w3.org/TR/geolocation-API/#position_options_interface).
   * @observable
   * @api
   */


  Geolocation.prototype.getTrackingOptions = function () {
    return (
      /** @type {PositionOptions|undefined} */
      this.get(Property.TRACKING_OPTIONS)
    );
  };
  /**
   * Set the projection to use for transforming the coordinates.
   * @param {import("./proj.js").ProjectionLike} projection The projection the position is
   *     reported in.
   * @observable
   * @api
   */


  Geolocation.prototype.setProjection = function (projection) {
    this.set(Property.PROJECTION, (0, _proj.get)(projection));
  };
  /**
   * Enable or disable tracking.
   * @param {boolean} tracking Enable tracking.
   * @observable
   * @api
   */


  Geolocation.prototype.setTracking = function (tracking) {
    this.set(Property.TRACKING, tracking);
  };
  /**
   * Set the tracking options.
   * See http://www.w3.org/TR/geolocation-API/#position-options.
   * @param {PositionOptions} options PositionOptions as defined by the
   *     [HTML5 Geolocation spec
   *     ](http://www.w3.org/TR/geolocation-API/#position_options_interface).
   * @observable
   * @api
   */


  Geolocation.prototype.setTrackingOptions = function (options) {
    this.set(Property.TRACKING_OPTIONS, options);
  };

  return Geolocation;
}(_Object["default"]);

var _default = Geolocation;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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